import { useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import useCheckCallConnected from "../../hooks/useCheckCallConnected";

import { GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import { CALL_BODY_SCREEN, ENABLED, EXTRACT_TEXT_VIEW } from "../../constants/Constants";

import uploadFilesService from "../../services/uploadFilesService";
import livePointerService from "../LivePointer/livePointerService";
import extractTextService from "../../services/extractTextService";
import GalleryViewTooltip from "../UI/Tooltip/GalleryViewTooltip";
import useShowGalleryViewTooltip from "../../hooks/useShowGalleryViewTooltip";

const ExtractTextButton = () => {
    const isCallNotConnected = useCheckCallConnected();
    const showGalleryViewTooltip = useShowGalleryViewTooltip();
    const localisedValues = useLanguageChange();
    const { allowMarkup, currentCallBodyScreen } = useSelector((state) => state.commonReducer);
    const { extractTextInprogress } = useSelector((state) => state.extractText);
    const { livePointerInProgress } = useSelector((state) => state.livePointer);

    const checkButtonDisabled = () => {
        /* for multiple click handle - add condition for mark up inprogress*/
        return (
            uploadFilesService.isUploadFilesView() ||
            !allowMarkup ||
            currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN ||
            livePointerInProgress ||
            extractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW ||
            extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW
        );
    };

    const startExtractText = () => {
        if (extractTextInprogress === EXTRACT_TEXT_VIEW.OFF_VIEW) {
            // call this function (checkLiveLocation()) to check if live location is on then close it
            livePointerService.livePointerOnMarkupOCR();
            extractTextService.createOCRPhoto();
        }
    };

    return (
        <>
            {GLOBAL_MEETING_DATA.isAgent && PublicVariables.featureFlag?.SHOWMEOCR === ENABLED && (
                <div className='action-button' data-testid='extractText-button-component'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className='call-action-btn'
                            disabled={isCallNotConnected || checkButtonDisabled()}
                            onClick={startExtractText}
                            data-testid='extractText-button'
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-extract-text'></span>
                            </span>
                            <span className='for-text'>{localisedValues["extract_text"]}</span>
                        </button>
                        {showGalleryViewTooltip && !checkButtonDisabled() && <GalleryViewTooltip localisedValues={localisedValues} />}
                    </div>
                </div>
            )}
        </>
    );
};

export default ExtractTextButton;
